/**
 * Константы метрик для робо-эдвайзера
 * Используются для отправки аналитики в Yandex.Metrika
 */
export const RoboMetrics = Object.freeze({
  // Открытие робо-эдвайзера
  ROBO_OPENED: 'robo_opened',

  // Работа со стратегиями
  ROBO_STRATEGY_SELECTED: 'robo_strategy_selected',
  ROBO_STRATEGY_VIEWED: 'robo_strategy_viewed',

  // Оформление подписки
  ROBO_SUBSCRIPTION_STARTED: 'robo_subscription_started',
  ROBO_SUBSCRIPTION_FORM_SUBMITTED: 'robo_subscription_form_submitted',
  ROBO_SUBSCRIPTION_FORM_SUCCESS: 'robo_subscription_form_success',
  ROBO_SUBSCRIPTION_FORM_ERROR: 'robo_subscription_form_error',

  // Согласие с правилами
  ROBO_CONTRACT_ACCEPTED: 'robo_contract_accepted',

  // SMS верификация
  ROBO_SMS_SENT: 'robo_sms_sent',
  ROBO_SMS_VERIFIED: 'robo_sms_verified',
  ROBO_SMS_VERIFICATION_FAILED: 'robo_sms_verification_failed',

  // Работа с брокером
  ROBO_BROKER_SELECTED: 'robo_broker_selected',
  ROBO_BROKER_SETUP_STARTED: 'robo_broker_setup_started',
  /** Клик по «Открыть счёт в …» (реферальная ссылка брокера) на шаге подключения */
  ROBO_BROKER_OPEN_ACCOUNT_CLICK: 'robo_broker_open_account_click',
  ROBO_BROKER_CONNECTED: 'robo_broker_connected',

  // Успешное завершение
  ROBO_CONNECTED_SUCCESS: 'robo_connected_success',

  // Переходы между шагами
  ROBO_STEP: 'robo_step',

  // Скачивание приложения с веба (клик по кнопке «Скачать» в баннере на сайте)
  ROBO_IOS: 'robo_ios',
  ROBO_ANDROID: 'robo_android',
});
